if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.submitEl = this.querySelector('[data-sticky-submit]');
        this.sectionId = this.dataset.section;
        this.sync = this.sync.bind(this);
        this.onIntersect = this.onIntersect.bind(this);
        this.sync();
        this.observeSources();
        this.observeVisibility();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        document.body.classList.remove('has-sticky-atc');
      }

      sourcePrice() {
        return document.getElementById(`price-${this.sectionId}`);
      }

      sourceButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      observeSources() {
        const price = this.sourcePrice();
        const button = this.sourceButton();
        if (!price && !button) return;

        this.mutationObserver = new MutationObserver(this.sync);
        if (price) {
          this.mutationObserver.observe(price, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class', 'hidden'],
          });
        }
        if (button) {
          this.mutationObserver.observe(button, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['disabled', 'class'],
          });
        }
      }

      observeVisibility() {
        const button = this.sourceButton();
        if (!button) return;

        this.visibilityObserver = new IntersectionObserver(this.onIntersect, {
          threshold: 0.2,
        });
        this.visibilityObserver.observe(button);
      }

      onIntersect(entries) {
        const visible = entries.some((entry) => entry.isIntersecting);
        this.hidden = visible;
        document.body.classList.toggle('has-sticky-atc', !visible);
      }

      sync() {
        const price = this.sourcePrice();
        const button = this.sourceButton();

        if (price && this.priceEl) {
          this.priceEl.innerHTML = price.innerHTML;
          this.priceEl.hidden = price.classList.contains('hidden');
        }

        if (button && this.submitEl) {
          const label = button.querySelector('span');
          const text = (label ? label.textContent : button.textContent).replace(/\s+/g, ' ').trim();
          if (text) this.submitEl.textContent = text;
          this.submitEl.disabled = button.hasAttribute('disabled');
        }
      }
    }
  );
}
